import { useContext, useEffect, useState } from "react";
//Components
import ArrestInformation from "./ArrestInformation";
import { AppBar, Tabs, Tab, Typography, Box } from "@material-ui/core";
//styling
import { useStyles } from "../Styles/styles";
//utils
import PropTypes from "prop-types";
import { UserContext } from "../Contexts/UserContext";
import { IncidentsContext } from "../Contexts/IncidentsContext";
import { INCIDENT_ACTIONS } from "../Actions/IncidentActions";
import {
  createEmptyIncidentArrest,
  createEmptyIncidentDetail,
} from "../utils/EmptyObjects";
import { MutationContext } from "../Contexts/MutationContext";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={1}>
          <Typography component={"div"}>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`,
  };
}

const ArrestInformationTabs = ({
  incidentIndex,
  incidentId,
  incidentUuid,
  incidentArrests,
  piss,
  incident,
  userRoles,
  setPausePolling,
  _arrestInformationIsMounted,
  incidentOfficers,
  getPissForIncident,
  ...props
}) => {
  const classes = useStyles();
  const [arrestTab, setArrestTab] = useState(0);
  const { user, onlineState } = useContext(UserContext);
  const { incidentDispatch, incidents } = useContext(IncidentsContext);
  const { UPDATE_INCIDENT } = INCIDENT_ACTIONS;
  const { updateArrestInIncident } = useContext(MutationContext);

  const handleChange = (event, newValue) => {
    setArrestTab(newValue);
  };

  useEffect(() => {
    _arrestInformationIsMounted.current = true;
    return () => {
      // ComponentWillUnmount in Class Component
      _arrestInformationIsMounted.current = false;
    };
  }, [_arrestInformationIsMounted]);

  useEffect(() => {
    if (onlineState || import.meta.env.VITE_FORCE_ONLINE === "true") {
      getPissForIncident?.();
    }
  }, [getPissForIncident, onlineState]);

  //Add useEffect that adds an incidentArrest and an incidentDetail
  //The incidentDetail will need to see if one already exists (ie the tab was already clicked) and if an incidentDetailId exists on the incident
  //Create a full incidentDetail if it doesn't exist (use the same checking for id as IncidentPanel.js)
  useEffect(() => {
    if (
      !onlineState &&
      import.meta.env.VITE_FORCE_ONLINE !== "true" &&
      (!incidentArrests || incidentArrests?.length === 0)
    ) {
      const emptyArrest = createEmptyIncidentArrest(user);
      incidentDispatch({
        type: UPDATE_INCIDENT,
        payload: {
          id: incidentId,
          uuid: incidentUuid,
          incidentIndex: incidentIndex,
          property: "incidentArrests",
          value: [emptyArrest],
        },
      });
      //Because the user is set automatically, also send a mutation to update the arresting officer
      updateArrestInIncident({
        variables: {
          input: {
            incidentArrestId: emptyArrest.id,
            incidentId: incidentId,
            originatorId: user?.id,
            arrestorId: user?.id,
          },
        },
      });
    }

    if (
      !onlineState &&
      import.meta.env.VITE_FORCE_ONLINE !== "true" &&
      !incidents[incidentIndex]?.incidentDetail
    ) {
      let emptyIncidentDetail = createEmptyIncidentDetail();
      //If the user is in an incident that exists online, the incidentDetailId and incidentReviewId are created and must be referenced
      emptyIncidentDetail.id = incident?.incidentDetailId
        ? incident?.incidentDetailId
        : emptyIncidentDetail.id;
      emptyIncidentDetail.uuid = incident?.incidentDetailId
        ? incident?.incidentDetailId
        : emptyIncidentDetail.uuid;
      incidentDispatch({
        type: UPDATE_INCIDENT,
        payload: {
          id: incidentId,
          uuid: incidentUuid,
          property: "incidentDetail",
          value: emptyIncidentDetail,
        },
      });
    }
  });
  // if (arrestsLoading) return <div><CircularProgress data-cy="loading-circle" /></div>
  // if (arrestsError) return <p>Error: {arrestsError}</p>
  // if (arrestsData) {
  return (
    <div style={{ border: "1px solid black" }} className={classes.tabsDiv}>
      <AppBar position="static" color="default">
        <Tabs
          value={arrestTab}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          aria-label="scrollable arrest tabs"
        >
          {incidentArrests?.map((arrest, index) => {
            return (
              <Tab
                key={arrest.id}
                label={`Arrest ${arrest.id}`}
                {...a11yProps(index)}
              />
            );
          })}
        </Tabs>
      </AppBar>
      {incidentArrests?.map((arrest, index) => {
        return (
          <TabPanel key={arrest.id} value={arrestTab} index={index}>
            <ArrestInformation
              key={arrest.id}
              arrest={arrest}
              arrestIndex={index}
              incidentId={incidentId}
              incidentIndex={incidentIndex}
              arrestsLength={incidentArrests?.length}
              piss={piss}
              arrestTab={arrestTab}
              setArrestTab={setArrestTab}
              incident={incident}
              userRoles={userRoles}
              setPausePolling={setPausePolling}
              incidentOfficers={incidentOfficers}
              {...props}
            />
          </TabPanel>
        );
      })}
    </div>
  );
  // } else {
  //   return <div><CircularProgress data-cy="loading-circle" /></div>
  // }
};

export default ArrestInformationTabs;
